import React, { useState, useEffect, useRef, useContext , useMemo } from "react";
import { useFormContext } from "../createworkflow/FormContext";
import CustomizedDialogs from "./CustomizedDialogs";
import { ErrorBoundary } from "../common/ErrorBoundary";
import Select from "react-select";
import {
  DataFrequency,
  ForecastPeriods,
  GranularityList
} from "../../Utils/dataTemporialSettings";
import styled from "styled-components";
import { getForecastPeriods } from "../../services/ApiWorkflow";
import { setValue, isEmpty, displayMessage } from "../../Utils/helper";
import { getDateRanges } from '../../services/ApiWorkflow';
import Loader from '../common/Loader'
import { toggleErrorVisibility } from "./helper";
import {DataContext} from './DataContext';
import { months , weeks}  from '../../Utils/dataSeasonality'

export default function Stage2() {

  const { formData, updateFormData } = useFormContext();
  const [modalShow, setModalShow] = React.useState(false);

  //below are variables for data frequency, forecast frequency and forecast period
  const [selDataFrequency, setSelDataFrequency] = useState(formData?.stage2?.data_frequency);
  const [selProductCategory, setSelProductCategory] = useState(formData?.stage2?.product_category);
  const [selForecastFrequency, setSelForecastFrequency] = useState(formData?.stage2?.forecast_frequency);
  const [disabledGranularity, setDisabledGranularity] = useState([]);
  const [defaultGranularity, setDefaultGranularity] = useState(formData?.stage2?.forecast_frequency);

  const [trainPercentage, setTrainPercentage] = useState(formData?.stage2?.train_percentage);
  const [testPercentage, setTestPercentage] = useState(formData?.stage2?.test_percentage);



  const [dateObject, setDateObject] = useState({});
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const trainPercentageRef = useRef();
  const testPercentageRef = useRef();

  const refDataFrequency = useRef(null);
  const refLblerrDataFrequency = useRef();
  const refForecastPeriod = useRef();
  const refLblerrForecastPeriod = useRef();
  const refLblerrProductCategory = useRef();

  const { products , isDataloading } = useContext(DataContext);
  //const productCategories = []
  const productCategories = useMemo(()=>products?.data?.level1?.map(elem => { return { label: elem.name, value: elem.level1_id }}), [products]);

  //console.log(formData);

  useEffect(() => {
    try {
      const init = async () => {
        if(formData?.stage1?.data_upload_id !== null){
        setIsLoading(true);
        let _dateObject = await getDateRanges(formData?.stage1?.data_upload_id);
        setDateObject(_dateObject);
        setIsLoading(false);
        setDate(_dateObject)
        }
        else{
          displayMessage('danger','Insufficient Data','Please Upload file in Initialize workflow');
        }
      }
      init();
    } catch (err) { 
      console.log(err);
      setError(err);
    }
  }, [])

  useEffect(() => {
    try{
      if (!formData?.stage2?.isValid) {
        const { data_frequency, forecast_period , product_category } = formData?.stage2?.errors || {};
        
        //if variable 'data_frequency' is null then display error message
        toggleErrorVisibility(data_frequency, refDataFrequency.current.controlRef, refLblerrDataFrequency.current);
        toggleErrorVisibility(forecast_period, refForecastPeriod.current.controlRef, refLblerrForecastPeriod.current);
        toggleErrorVisibility(product_category, refLblerrProductCategory.current.controlRef, refLblerrProductCategory.current);
        
      }
    }catch(error){
      console.log(error);
 
    }
    }, [])

  if (error) {
    return <div>Error: {error.message}</div>; // Fallback UI
  }

  const setDate = (_dateObject) => {
    updateFormData("stage2", {
      ...formData.stage2,
      ['start_date']: _dateObject.avail_from,
      ['end_date']: _dateObject.avail_to,
    });


  }
  const changeDate = (e) => {
    updateFormData("stage2", {
      ...formData.stage2,
      ['start_date']: e.target.value,
      ['end_date']: dateObject.avail_to
    });
  }

  const handleTrainingPeriodChange = (e) => {
    const { name, value } = e.target;
    const numTrainPercentage = Number(value);

    setTrainPercentage(numTrainPercentage);
    setTestPercentage(100 - numTrainPercentage);

    testPercentageRef.current.value = 100 - numTrainPercentage;

    updateFormData("stage2", {
      ...formData.stage2,
      ['train_percentage']: numTrainPercentage,
      ['test_percentage']: 100 - numTrainPercentage
    });

  }

  const handleModelItemClick = (e) => {
    setModalShow(true);
  };

  const handleChangeDataFrequency = (selected) => {
    setSelDataFrequency(selected.value);
    let result = DataFrequency.find(elem => elem.value == selected.value).disabledValues;
    setDisabledGranularity(result);
    let defaultGranValue = ['transaction', 'daily'].includes(selected.value.toLowerCase()) ? 'Weekly' : selected.value;
    setDefaultGranularity(defaultGranValue);
    setSelForecastFrequency(defaultGranValue);
    funcUpdateSeasonalityData(defaultGranValue);

    updateFormData("stage2", {
      ...formData.stage2,
      ['data_frequency']: selected.value,
      ['forecast_frequency']: defaultGranValue,
      ['defaultGranValue']: defaultGranValue
    });

    toggleErrorVisibility(selected.value === null, refDataFrequency.current.controlRef, refLblerrDataFrequency.current);

  }

  const handleChangeProductCategory = (selected) => {
    setSelProductCategory(selected.value);
    updateFormData("stage2", {
      ...formData.stage2,
      ['product_category']: selected.value
    });

  }

  function funcUpdateSeasonalityData(frequency){
    let seasonality_data = [];
    switch(frequency.toLowerCase()){
      case 'weekly' : seasonality_data = weeks;break;
      case 'monthly' : seasonality_data = months;break;
      default : seasonality_data = []; break;
    }
  
    updateFormData("stage5", {
      ...formData.stage5,
      ['seasonality_data']:seasonality_data
    });
  }

  const rdGranularityOnChangeHandler = (e) => {
    setValue('session', 'form', "granularity", e.target.id);
    setSelForecastFrequency(e.target.id);

    updateFormData("stage2", {
      ...formData.stage2,
      ['forecast_frequency']: e.target.id
    });
    funcUpdateSeasonalityData(e.target.id);

  }

  const handleChangeForecastPeriod = (selected) => {
    // console.log(selected.value);
    updateFormData("stage2", {
      ...formData.stage2,
      ['forecast_period']: selected.value
    });

    toggleErrorVisibility(selected.value === null, refForecastPeriod.current.controlRef, refLblerrForecastPeriod.current);
  }


  const formatDate = (date) => {
    const [year, month,day] = date ? date.split("-") : ""
    return `${day}-${month}-${year}`;
  };



  return (
    <ErrorBoundary>
      <div className="row">
        <div className="col-md-12 col-sm-12 col-xs-12">
          <div className="createworkflowtabcontents">
            <div id="stage2">
              <div className="col-md-12 col-sm-12 col-xs-12">
                {isLoading ? <Loader size="small" /> :
                  <div className="flex gap-x-7">
                    <div className="creatnote">
                      * Data available for forecast is
                      between&nbsp;{formatDate(dateObject?.avail_from)}&nbsp;to&nbsp;{formatDate(dateObject?.avail_to)}
                    </div>
                    <div className="mt-4 space-x-2">
                      <label>Change Start Date</label>
                      <input
                        type="date"
                        defaultValue={formatDate(dateObject?.avail_from || '')} // Default value
                        onChange={(e) => changeDate(e)}
                        min={formatDate(dateObject?.avail_from)}
                        max={formatDate(dateObject?.avail_to)}
                        className="px-2 border border rounded"
                      />
                    </div>
                  </div>
                }
              </div>
              <div className="col-md-12 col-sm-12 col-xs-12 padding">
                <div className="col-md-4 col-sm-4 col-xs-12">
                  <div className="form-group1">
                    <label>
                      Data Frequency<span>*</span>
                    </label>
                    <Select
                      key="dataFrequency"
                      id="dataFrequency"
                      ref={refDataFrequency}
                      options={DataFrequency}
                      onChange={handleChangeDataFrequency}
                      defaultValue={{ label: formData?.stage2?.data_frequency, value: formData?.stage2?.data_frequency }}
                      classNames={{
                        control: (state) =>
                          state.isFocused ? 'form-control' : 'form-control',
                      }}
                      styles={{
                        control: (baseStyles, state) => ({
                          ...baseStyles,
                          borderColor: state.isFocused ? '#66afe9' : '#D9D9D9',
                          outline: 0,
                          boxShadow: state.isFocused ? 'inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 8px rgba(102, 175, 233, .6)' : 'none'
                        }),
                      }}
                    />
                    <label
                      id="lblerr_data_frequency"
                      ref={refLblerrDataFrequency}                    
                      className="invalid-feedback hidden"
                    >
                      * Required
                    </label>
                  </div>
                </div>
                <div className="col-md-4 col-sm-4 col-xs-12">
                <div className="form-group1">
                    <label>
                      Product Category<span>*</span>
                    </label>               
                      <Select 
                      key="productCategory"
                      id="productCategory"
                      onChange={handleChangeProductCategory}
                      options={productCategories}
                      defaultValue={productCategories?.find(elem => elem.value == formData?.stage2?.product_category)}
                      classNames={{
                        control: (state) =>
                          state.isFocused ? 'form-control' : 'form-control',
                      }}
                      styles={{
                        control: (baseStyles, state) => ({
                          ...baseStyles,
                          borderColor: state.isFocused ? '#66afe9' : '#D9D9D9',
                          outline: 0,
                          boxShadow: state.isFocused ? 'inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 8px rgba(102, 175, 233, .6)' : 'none'
                        }),
                      }}
                    />
                    <label
                      id="lblerr_product_category"
                      ref={refLblerrProductCategory}
                      className="invalid-feedback hidden"
                    >
                      * Required
                    </label>
                </div>
                </div>
              </div>
              <div className="col-md-12 col-sm-12 col-xs-12 padding">
                <div className="col-md-1 col-sm-1 col-xs-12">
                  <div className="form-group1">
                    <label htmlFor="train_percentage">
                      Training Period (%)<span>*</span>
                    </label>
                    <input
                      type="number"
                      ref={trainPercentageRef}
                      className="form-control"
                      id="train_percentage"
                      name="train_percentage"
                      onChange={handleTrainingPeriodChange}
                      defaultValue={trainPercentage}
                      min={0}
                      max={100}
                      placeholder=""
                    />
                  </div>
                </div>
                <div className="col-md-1 col-sm-1 col-xs-12">
                  <div className="form-group1">
                    <label htmlFor="test_percentage">
                      Testing Period (%)
                    </label>
                    <input
                      type="number"
                      ref={testPercentageRef}
                      disabled
                      name="test_percentage"
                      className="form-control"
                      id="test_percentage"
                      min={0}
                      max={100}
                      defaultValue={testPercentage}
                      placeholder=""
                    />
                  </div>
                </div>
              </div>



              <div className="col-md-12 col-sm-12 col-xs-12 space">
                <div className="form-group1">
                  <label>
                    Forecast frequency<span>*</span>
                  </label>
                  <div>
                    <Stage2RadiobuttonList
                      DefaultValue={formData?.stage2?.defaultGranValue}
                      DisabledValues={disabledGranularity}
                      OnSelectChange={rdGranularityOnChangeHandler}
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-12 col-sm-12 col-xs-12 padding">
                <div className="col-md-8 col-sm-8 col-xs-12">
                  <div className="form-group1">
                    <label>
                      Forecast Period<span>*</span>
                    </label>
                    <Select
                      key="forecastPeriod"
                      id="forecastPeriod"
                      ref={refForecastPeriod}
                      options={getForecastPeriods(selForecastFrequency)}
                      onChange={handleChangeForecastPeriod}
                      defaultValue={{ label: formData?.stage2?.forecast_period, value: formData?.stage2?.forecast_period }}
                      classNames={{
                        control: (state) =>
                          state.isFocused ? 'form-control' : 'form-control',
                      }}
                      styles={{
                        control: (baseStyles, state) => ({
                          ...baseStyles,
                          borderColor: state.isFocused ? '#66afe9' : '#D9D9D9',
                          outline: 0,
                          boxShadow: state.isFocused ? 'inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 8px rgba(102, 175, 233, .6)' : 'none'
                        }),
                      }}
                    />
                    <label
                      id="lblerr_forecast_period"
                      ref={refLblerrForecastPeriod}
                      className="invalid-feedback hidden"
                    >
                      * Required
                    </label>
                  </div>
                </div>
              </div>
              {/* <div className="col-md-12 col-sm-12 col-xs-12">
                <div className="form-group1">
                  <label>Dealer Promotions</label>
                  <div className="temporalpopupbtn">
                    <ul>
                      <li>
                        <CustomizedDialogs ModuleName="FOC" />
                      </li>
                      <li>
                        <CustomizedDialogs ModuleName="ED" />
                      </li>
                      <li>
                        <CustomizedDialogs ModuleName="X1" />
                      </li>
                      <li>
                        <CustomizedDialogs ModuleName="X2" />
                      </li>
                    </ul>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </ErrorBoundary>
  );
}

function Stage2RadiobuttonList({
  DefaultValue,
  DisabledValues,
  OnSelectChange,
}) {

  const { formData, updateFormData } = useFormContext();

  // State to manage the checked status of the radio buttons
  const [checkedOption, setCheckedOption] = useState(DefaultValue); // Set Option 1 as checked initially

  useEffect(() => {
    setCheckedOption(DefaultValue);
  }, [DefaultValue]);

  // Function to handle radio button change
  const handleRadioChange = (e) => {
    setCheckedOption(e.target.value); // Update the checked option based on user selection
    OnSelectChange(e);

  };

  const isItemDisabled = (item) => {
    let result = DisabledValues.includes(item);
    return result;
  };
  return (
    <RadioListWrapper>
      {GranularityList.map((elem, index) => (
        <div key={index}>
          <label htmlFor={`${elem.id}`} className="radio-inline">
            <input
              id={`${elem.id}`}
              type="radio"
              name="granularity"
              value={elem.id}
              checked={checkedOption === elem.id}
              disabled={isItemDisabled(elem.id)}
              onChange={handleRadioChange}
            />{" "}
            {elem.label}
          </label>
        </div>
      ))}
    </RadioListWrapper>
  );
}

const RadioListWrapper = styled.div`
  .radio-inline {
    padding-right: 4%;
  }
`;
